import { translation, formatToReactComponent, TranslatedComponent } from '@hh.ru/front-static-app';
import { Link, Text, useBreakpoint } from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';

const TrlKeys = {
    oferta: 'hhpro.promo.apply.orerta',
    ofertaLink: 'hhpro.promo.apply.orerta.link',
};

const Oferta: TranslatedComponent = ({ trls }) => {
    const breakpoint = useBreakpoint();
    const typography = breakpoint.isGtS ? 'label-2-regular' : 'label-4-regular';
    return (
        <Text style="contrast-secondary" typography={typography}>
            {formatToReactComponent(trls[TrlKeys.oferta], {
                '{link}': (
                    <Link
                        inline
                        Element={SPALink}
                        to="/article/hhpro_offer"
                        style="contrast"
                        target="_blank"
                        typography={typography}
                    >
                        {trls[TrlKeys.ofertaLink]}
                    </Link>
                ),
            })}
        </Text>
    );
};

export default translation(Oferta);
